import type { CoreLayoutProps } from 'ra-core';
import { Layout } from '@/components/admin/layout';
import { SelecteurDeStructure } from './SelecteurDeStructure';

/**
 * **LE CADRE — LE LAYOUT DE LA PEAU, PLUS LA SEULE CHOSE QUE F-55 EXIGE EN TÊTE.**
 *
 * F-55 veut « un sélecteur **permanent en tête de la surface** ». Le `Layout` de la peau a
 * son propre en-tête, dont le contenu est figé dans un fichier recopié — qu'on ne retouche
 * pas. Le sélecteur entre donc **par les enfants**, en première position : il est en tête de
 * la colonne de contenu, présent sur tous les écrans, et **zéro ligne de la peau dupliquée**.
 *
 * ───────────────────────────────────────────────────────────────────────────
 * **LA PREMIÈRE VERSION LE PLAÇAIT AU-DESSUS DU `Layout`, ET LE MENU LE RECOUVRAIT —
 * corrigé le 20260826, constaté en recette.**
 * ───────────────────────────────────────────────────────────────────────────
 *
 * Elle posait une barre pleine largeur **avant** le `Layout`, au motif que c'était
 * « littéralement en tête de la surface ». **Le motif était juste dans l'arbre du document et
 * faux à l'écran** : `components/ui/sidebar.tsx` rend le menu en `fixed inset-y-0 z-10`, donc
 * **ancré au haut de la FENÊTRE et non au haut de son parent**. Un élément placé au-dessus du
 * `Layout` occupe une bande que le menu recouvre intégralement.
 *
 * **Ce que ça donnait, et pourquoi la revue de code ne pouvait pas le voir** : le déclencheur
 * fait 280 px, le menu 256 px — **seuls les 24 derniers pixels dépassaient**, c'est-à-dire le
 * chevron seul, sans étiquette, à côté du logo du menu. Le sélecteur *existait*, il *marchait*,
 * et **il était invisible**. Aucun test, aucun lint, aucune lecture de ce fichier ne l'atteint :
 * il fallait ouvrir la page. C'est le motif de D-100 sur une géométrie.
 *
 * **Pourquoi l'entrée par les enfants et pas un `z-index`.** Remonter la barre au-dessus du
 * menu la ferait recouvrir l'en-tête du menu à son tour : on échangerait un élément caché
 * contre un autre. Et repousser le menu vers le bas demanderait de retoucher `sidebar.tsx`,
 * ce que le contrôle d'empreinte refuse. **Les enfants du `Layout` sont rendus dans la colonne
 * de contenu, à droite du menu** : aucun recouvrement possible, et le sélecteur reste au-dessus
 * de tous les écrans.
 *
 * **Le sélecteur n'a pas changé d'une ligne** : le défaut était dans le cadre, pas en lui.
 */
export function Cadre(props: CoreLayoutProps) {
  return (
    <Layout {...props}>
      {/* La barre ne se rend pas du tout pour un `orgadmin` : le sélecteur rend `null`, et
          `empty:hidden` fait disparaître la barre avec lui — plutôt qu'une bande vide qui
          laisserait croire à un élément non chargé. Pas de padding horizontal : la colonne
          de contenu du `Layout` porte déjà `px-4`, et en ajouter décalerait le sélecteur des
          écrans qu'il surmonte. */}
      <div className="flex shrink-0 items-center gap-3 border-b pb-2 empty:hidden">
        <SelecteurDeStructure />
      </div>
      {props.children}
    </Layout>
  );
}
